export default "__VITE_ASSET__VX$WZzf8__"